




























































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { StudyDummyBaseMethod } from '@/mixins/requests/student/StudyApis.vue'
import { QuestionAnswerType } from '@/mixins/requests/student/StudyApis.vue'
import 'mobile-drag-drop/default.css'
import draggable from 'vuedraggable'

@Component({
  components: {
    draggable,
  },
})
export default class StudyDummy8 extends Vue implements StudyDummyBaseMethod {
  /** 選択肢 */
  private choices = [
    { id: 1, text: '夜間は発電できない' },
    { id: 2, text: '日本では世界に比べてコストが高い' },
    { id: 3, text: '小さなスペースで設置可能' },
    { id: 4, text: '開発初期に長期にわたる調査が必要' },
    { id: 5, text: '天気に関わらず一定量の電力を供給可能' },
    { id: 6, startText: 'エネルギーに', rb: '交換', rt: 'こうかん', endText: 'するときの効率が良い' },
  ]

  /** D＆Dの可否を判断するフラグ */
  private dragFlag = [
    { id: 1, draggable: false },
    { id: 2, draggable: false },
    { id: 3, draggable: false },
    { id: 4, draggable: false },
    { id: 5, draggable: false },
    { id: 6, draggable: false },
  ]

  @Prop()
  currentQuestionAnswer?: QuestionAnswerType

  /**
   * 初回表示以降、ページ遷移後に再表示した際に復元した解答状況を表示する
   */
  private mounted() {
    this.restoreInputedElements()
  }

  /**
   * 解答を生成
   */
  public getQuestionAnswer(): QuestionAnswerType {
    // 入力値（選択肢のコード01〜06）を取得
    let selectedValues = []
    for (var i = 1; i < 7; i++) {
      let element = (document.getElementById(`dropbox0${i}`) as HTMLElement).firstElementChild
      selectedValues.push(element ? element.id.replace('answer-text-', '') : '')
    }
    return { inputs: selectedValues }
  }

  /**
   * 解答状況を復元する
   */
  public restoreInputedElements(): void {
    // 初回起動時に処理に入らないようにするためのガード処理
    if (!this.currentQuestionAnswer || !this.currentQuestionAnswer.inputs) return

    let tableInnerHtml = [
      '<li data-v-ecc86792="" id="answer-text-01" class="answer-text" draggable="false" style="">夜間は発電できない<!----></li>',
      '<li data-v-ecc86792="" id="answer-text-02" class="answer-text" draggable="false" style="">日本では世界に比べてコストが高い<!----></li>',
      '<li data-v-ecc86792="" id="answer-text-03" class="answer-text" draggable="false" style="">小さなスペースで設置可能<!----></li>',
      '<li data-v-ecc86792="" id="answer-text-04" class="answer-text" draggable="false" style="">開発初期に長期にわたる調査が必要<!----></li>',
      '<li data-v-ecc86792="" id="answer-text-05" class="answer-text"" draggable="false" style="">天気に関わらず一定量の電力を供給可能<!----></li>',
      '<li data-v-ecc86792="" id="answer-text-06" class="answer-text"><!---->エネルギーに<ruby data-v-ecc86792=""><rb data-v-ecc86792="">交換</rb><rp data-v-ecc86792="">（</rp><rt data-v-ecc86792="">こうかん</rt><rp data-v-ecc86792="">）</rp></ruby>するときの効率が良い</li>',
    ]
    let draggableTable = document.getElementById('draggableTable') as HTMLElement
    let tableCells = draggableTable.getElementsByTagName('div')
    let draggableChoices = document.getElementById('draggableChoices') as HTMLElement

    // 入力値を復元
    for (let i = 0; i < this.currentQuestionAnswer.inputs.length; i++) {
      const value = this.currentQuestionAnswer.inputs[i]
      // テーブルデータを復元しそれに伴って選択肢削除
      if (value) {
        let choices = draggableChoices.querySelector('li:nth-child(' + Number(value) + ')') as Element
        let child = document.getElementById('answer-text-' + value) as HTMLElement
        let index = Number(value) - 1

        tableCells[i].insertAdjacentHTML('beforeend', tableInnerHtml[index])
        let firstElementChild = tableCells[i].firstElementChild as Element
        // テーブルセルに復元した選択肢にイベントを再設定
        this.addStartEvent('dragstart', firstElementChild)
        this.addEndEvent('dragend', firstElementChild)
        this.addStartEvent('touchstart', firstElementChild)
        this.addEndEvent('touchend', firstElementChild)
        // テーブルセルに選択肢を復元した際、不要な元の選択肢を削除
        choices.removeChild(child)
      }
    }
  }

  /**
   * テーブルセルに復元した選択肢にdragstart/touchstartイベント追加
   */
  private addStartEvent(eventHandler: string, firstElementChild: Element) {
    firstElementChild.addEventListener(
      eventHandler,
      function () {
        let id = Number(firstElementChild.id.slice(-1))
        // 現在ドラッグ中の要素を取得
        let dragElement = document.getElementById('answer-text-0' + String(id)) as HTMLElement

        for (let i = 0; i < 6; i++) {
          // テーブルセル内の要素を取得
          let dropbox = document.getElementById('dropbox0' + String(i + 1)) as HTMLElement
          if (dropbox.innerText != '' && dropbox.innerText != dragElement.innerText) {
            this[i].draggable = true
          }
        }
      }.bind(this.dragFlag)
    )
  }

  /**
   * テーブルセルに復元した選択肢にdragend/touchendイベント追加
   */
  private addEndEvent(eventHandler: string, firstElementChild: Element) {
    firstElementChild.addEventListener(eventHandler, this.enableDragElements, false)
  }

  /**
   * やり直しする際にテーブルと選択肢を初期化する
   */
  public clearInputedElements(): void {
    this.initializeTable()

    let draggableChoices = document.getElementById('draggableChoices') as HTMLElement
    let choices = Array.from(draggableChoices.getElementsByTagName('li'))
    // 未選択の選択肢の個数分処理を実行しないと完全に選択肢が生成されないためループ処理を実装
    for (let i = 0; i < choices.length; i++) {
      this.initializeChoices()
    }
  }

  /**
   * テーブルを初期化する
   */
  private initializeTable() {
    let draggableTable = document.getElementById('draggableTable') as HTMLElement
    let tableCells = Array.from(draggableTable.getElementsByTagName('div'))
    tableCells.forEach((tableCell: HTMLDivElement) => {
      tableCell.textContent = ''
    })
  }

  /**
   * 選択肢を初期化する
   */
  private initializeChoices() {
    let choicesInnerHTML = [
      '<li data-v-ecc86792="" id="answer-text-01" class="answer-text">夜間は発電できない<!----></li>',
      '夜間は発電できない<!---->',
      '<li data-v-ecc86792="" id="answer-text-02" class="answer-text">日本では世界に比べてコストが高い<!----></li>',
      '日本では世界に比べてコストが高い<!---->',
      '<li data-v-ecc86792="" id="answer-text-03" class="answer-text">小さなスペースで設置可能<!----></li>',
      '小さなスペースで設置可能<!---->',
      '<li data-v-ecc86792="" id="answer-text-04" class="answer-text">開発初期に長期にわたる調査が必要<!----></li>',
      '開発初期に長期にわたる調査が必要<!---->',
      '<li data-v-ecc86792="" id="answer-text-05" class="answer-text">天気に関わらず一定量の電力を供給可能<!----></li>',
      '天気に関わらず一定量の電力を供給可能<!---->',
      '<li data-v-ecc86792="" id="answer-text-06" class="answer-text"><!---->エネルギーに<ruby data-v-ecc86792=""><rb data-v-ecc86792="">交換</rb><rp data-v-ecc86792="">（</rp><rt data-v-ecc86792="">こうかん</rt><rp data-v-ecc86792="">）</rp></ruby>するときの効率が良い</li>',
      '<!---->エネルギーに<ruby data-v-ecc86792=""><rb data-v-ecc86792="">交換</rb><rp data-v-ecc86792="">（</rp><rt data-v-ecc86792="">こうかん</rt><rp data-v-ecc86792="">）</rp></ruby>するときの効率が良い',
    ]
    let draggableChoices = document.getElementById('draggableChoices') as HTMLElement
    let choices = Array.from(draggableChoices.getElementsByTagName('li'))

    choices.forEach((choice: HTMLLIElement, index: number) => {
      choice.innerHTML = ''
      choice.innerHTML = choicesInnerHTML[index]
    })
  }

  /**
   * テーブルに１つ以上選択肢をD&D出来ないようにフラグを変更する
   */
  private disableDropElemets(id: number) {
    // 現在ドラッグ中の要素を取得
    let dragElement = document.getElementById('answer-text-0' + String(id)) as HTMLElement
    for (let i = 0; i < this.choices.length; i++) {
      // テーブルセル内の要素を取得
      let dropbox = document.getElementById('dropbox0' + String(i + 1)) as HTMLElement
      if (dropbox.innerText != '' && dropbox.innerText != dragElement.innerText) {
        this.dragFlag[i].draggable = true
      }
    }
  }

  /**
   * テーブルから選択肢をD&D出来るようにフラグの値を変更する
   */
  private enableDragElements() {
    for (let i = 0; i < this.choices.length; i++) {
      if (this.dragFlag[i].draggable) {
        this.dragFlag[i].draggable = false
      }
    }
  }
}
